"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withStypesWrap = exports.StylesProvider = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var context_1 = require("./context");
var processor_1 = require("./processor");
var lodash_1 = tslib_1.__importDefault(require("lodash"));
var utils_1 = require("./utils");
var post_ssr_runtime_1 = require("../post-ssr-runtime");
var ValuesListById = /** @class */ (function () {
    function ValuesListById() {
        this.refs = {};
        this.values = [];
    }
    ValuesListById.prototype.subscribe = function (cb) {
        var _this = this;
        this.cb = cb;
        return function () {
            _this.cb = undefined;
        };
    };
    ValuesListById.prototype.notify = function () {
        if (this.cb) {
            this.cb();
        }
    };
    ValuesListById.prototype.getValues = function () {
        return this.values;
    };
    ValuesListById.prototype.addValue = function (id, order, value) {
        if (this.refs[id]) {
            this.refs[id]++;
            return;
        }
        this.refs[id] = 1;
        this.values.push({ id: id, value: value, order: order });
        this.values.sort(function (a, b) { return a.order - b.order; });
        this.notify();
    };
    ValuesListById.prototype.removeValue = function (id) {
        //   if (--this.refs[id] <= 0) {
        //     const index = this.values.findIndex(v => v.id === id);
        //     if (index === -1) {
        //       console.warn('why?');
        //       return;
        //     }
        //     this.values.splice(index, 1);
        //     console.log('remove', id);
        //     this.notify();
        //   }
    };
    return ValuesListById;
}());
function memoize(fn, isEq) {
    var memoizedVal = undefined;
    var prevArgs = [];
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (memoizedVal === undefined || !isEq(prevArgs, args)) {
            prevArgs = args;
            return (memoizedVal = fn.apply(void 0, tslib_1.__spread(args)));
        }
        return memoizedVal;
    };
}
var StylesProvider = /** @class */ (function (_super) {
    tslib_1.__extends(StylesProvider, _super);
    function StylesProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.getCssProcessor = memoize(function (wrapClassName, styleParams) {
            if (__DEV__) {
                console.log('creating new css processor');
            }
            var process = styleParams
                ? _this.processorFactory(styleParams)
                : function () {
                    throw new Error('Used process(), but styleParams is not passed');
                };
            var wrap = _this.props.wrapId ? "." + wrapClassName + " " : '';
            var cache = {};
            return function (styleId, css) {
                if (cache[styleId]) {
                    return cache[styleId];
                }
                // console.log('calc style ' + styleId);
                return (cache[styleId] = css(wrap, process));
            };
        }, function (prevArgs, newArgs) {
            return lodash_1.default.isEqual(prevArgs, newArgs);
        });
        _this.insertCss = function (stylesModule) {
            var _a = utils_1.processStyleModule(stylesModule), styleId = _a.styleId, order = _a.order, css = _a.css;
            _this.styles.addValue(styleId, order, css);
            return function () {
                _this.styles.removeValue(styleId);
            };
        };
        _this.processorFactory = processor_1.processorFactory(_this.props.cssVars);
        _this.styles = new ValuesListById();
        _this.props.subscribeGlobalStyles(function (styleModule) {
            _this.insertCss(styleModule);
        });
        return _this;
    }
    StylesProvider.prototype.getWrapClassName = function () {
        return this.props.wrapId ? "" + this.props.wrapId : 'comp';
    };
    StylesProvider.prototype.render = function () {
        var wrapClassName = this.getWrapClassName();
        var processor = this.getCssProcessor(wrapClassName, this.props.styleParams);
        return (react_1.default.createElement(context_1.StylesParamsContext.Provider, { value: { insertCss: this.insertCss } },
            react_1.default.createElement(post_ssr_runtime_1.PostSsrRuntime, null,
                react_1.default.createElement("div", { style: { display: 'none' }, className: wrapClassName }, this.props.children),
                react_1.default.createElement(StylesContainer, { wrapClassName: wrapClassName, styles: this.styles, processor: processor }),
                react_1.default.createElement(post_ssr_runtime_1.PostSSRRuntimeContext.Consumer, null, function (_a) {
                    var getContent = _a.getContent;
                    return getContent();
                }))));
    };
    return StylesProvider;
}(react_1.default.Component));
exports.StylesProvider = StylesProvider;
var StylesContainer = /** @class */ (function (_super) {
    tslib_1.__extends(StylesContainer, _super);
    function StylesContainer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.forceRerender = function () {
            _this.forceUpdate();
        };
        return _this;
    }
    StylesContainer.prototype.componentDidMount = function () {
        this.unsubscribe = this.props.styles.subscribe(this.forceRerender);
    };
    StylesContainer.prototype.componentWillUnmount = function () {
        this.unsubscribe();
    };
    StylesContainer.prototype.render = function () {
        // console.log('rendering StylesContainer');
        var _a = this.props, processor = _a.processor, styles = _a.styles, wrapClassName = _a.wrapClassName;
        var allStyles = styles
            .getValues()
            .map(function (st) { return (react_1.default.createElement("style", { id: st.id, key: st.id, dangerouslySetInnerHTML: { __html: processor(st.id, st.value) } })); });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            allStyles,
            react_1.default.createElement("style", { id: "_show-container", key: "_show-container", dangerouslySetInnerHTML: {
                    __html: "." + wrapClassName + " {display: block !important;}",
                } })));
    };
    return StylesContainer;
}(react_1.default.PureComponent));
exports.withStypesWrap = function (Comp, _a) {
    var cssVars = _a.cssVars, subscribeGlobalStyles = _a.subscribeGlobalStyles;
    return function (props) { return (react_1.default.createElement(StylesProvider, { wrapId: props.host.id, styleParams: props.host.style, cssVars: cssVars, subscribeGlobalStyles: subscribeGlobalStyles },
        react_1.default.createElement(Comp, tslib_1.__assign({}, props)))); };
};
//# sourceMappingURL=container.js.map